@if(true){
<div class="modal-body">
  <form [formGroup]="FollowUpForm" (ngSubmit)="onFollowUpFormSubmit(FollowUpForm.value);">
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-12 col-md-6">
            <div class="form-group">
              <label for="date" class="form-label">Date <span class="text-danger">*</span></label>
              <mat-form-field class="fullwidth" appearance="outline">
                <input matInput  [min]="DateofDecision" formControlName="FollowDate"
                  [max]="currentDate" [matDatepicker]="pickerFollowupdate" placeholder="Choose a date">
                <mat-datepicker-toggle matSuffix [for]="pickerFollowupdate"></mat-datepicker-toggle>
                <mat-datepicker #pickerFollowupdate></mat-datepicker>
              </mat-form-field>
              @if (f.FollowDate.touched && f.FollowDate.invalid) {
                @if (f.FollowDate.errors?.['required']) {
                  <mat-error>Follow Up Date is required.</mat-error>
                }
              }
            </div>
          </div>
          @if (!HideRows) {
          <div class="col-12 col-md-3">
            <div class="form-group">
              <label for="InTime" class="form-label">In Time</label>
                <input type="time" class="form-control" formControlName="InTime">
                @if (f.InTime.touched && f.InTime.invalid) {
                  <div class="text-danger">
                    <small>In Time is required.</small>
                  </div>
                }
            </div>
          </div>
          <div class="col-12 col-md-3">
            <div class="form-group">
              <label for="OutTime" class="form-label">Out Time</label>
                <input type="time" class="form-control" formControlName="OutTime">
                @if (f.OutTime.touched && f.OutTime.invalid) {
                  <div class="text-danger">
                    <small>Out Time is required.</small>
                  </div>
                }
            </div>
          </div>
          <div class="col-12 col-md-6">
            <div class="form-group">
              <label for="ActionType" class="form-label"> <a href="{{RouteFollowUpAction}}" target="_blank">Action
                  Type</a></label>
              <ng-select [items]="FollowUpAction" bindLabel="MainDescr" bindValue="hdID" formControlName="ActionType"
                [clearable]="false" placeholder="Select Action Type">
                <ng-template ng-option-tmp let-item="item">
                  <span [title]="item.MainDescr">{{item.MainDescr}}</span>
                </ng-template>
              </ng-select>
              @if (f.ActionType.touched && f.ActionType.invalid) {
                <div class="text-danger">
                  <small>Action Type is required.</small>
                </div>
              }
            </div>
          </div>
          <div class="col-12 col-md-6">
            <div class="form-group">
              <label for="ActionTaken" class="form-label">Action Taken <span class="text-danger">*</span></label>
              <textarea class="form-control" formControlName="ActionTaken" rows="2"
                placeholder="Enter Action Description"></textarea>
              @if (f.ActionTaken.touched && f.ActionTaken.invalid) {
                @if (f.ActionTaken.errors['required']) {
                  <div class="text-danger">
                    <small>Action Taken is required.</small>
                  </div>
                }
              }
            </div>
          </div>
          }
          <div class="col-12 col-md-6">
            <div class="form-group">
              <label for="followupFiles" class="form-label">Attachments</label>
              <input type='file' formControlName="followupFiles" (change)="onSelectFile($event)" multiple>
              @if (f.followupFiles.touched && f.followupFiles.invalid) {
                <div class="text-danger">
                  <small>Attachments is required.</small>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
    @if (!HideButtonSubmit) {
    @if ( (RightsID.includes('202046001')) ||
    (RightsID.includes('202046021')) ) {
    <div class="d-flex align-items-center justify-content-center mt-3">
      <button class="btn btn-primary submit-btn small" type="submit">
        {{ ButtonCaption }}
        <span *ngIf="loading" class="spinner-border spinner-border" role="status" aria-hidden="true"></span>
      </button>
    </div>
    }
    }
  </form>
</div>
}@else {
<!-- <div class="modal-body  col-sm-12 form-group">
      <form #FollowUp="ngForm" [formGroup]="FollowUpForm" (ngSubmit)="onFollowUpFormSubmit(FollowUp.value);">
  
          <div class="col-sm-4 height-34">Date<span style="color:red;">*</span></div>
          <div class="col-sm-6">
              <mat-form-field class="fullwidth">
                  <input matInput [readonly]="!editable" [min]="DateofDecision" formControlName="FollowDate" [max]="currentDate" [matDatepicker]="pickerFollowupdate" placeholder="Choose a date">
                  <mat-datepicker-toggle matSuffix [for]="pickerFollowupdate"></mat-datepicker-toggle>
                  <mat-datepicker #pickerFollowupdate></mat-datepicker>
              </mat-form-field>
          </div>
  
         
          <div class="col-sm-2">&nbsp;</div>
  
          <div class="col-sm-12">
              <hr>
          </div>
  
          <div class="col-sm-4 height-34" [hidden]="HideRows">In Time</div>
          <div class="col-sm-3" [hidden]="HideRows">
            <ng-select
              [items]="hours"
              formControlName="InHour"
              [clearable]="false"
              placeholder="Hour">
            </ng-select>
          </div>
          <div class="col-sm-3" [hidden]="HideRows">
            <ng-select
              [items]="minutes"
              formControlName="InMin"
              [clearable]="false"
              placeholder="Minutes">
            </ng-select>
          </div>
          <div class="col-sm-2" [hidden]="HideRows">&nbsp;</div>
  
          <div class="col-sm-12" [hidden]="HideRows">
              <hr>
          </div>
  
  
          <div class="col-sm-4 height-34" [hidden]="HideRows">Out Time</div>
          <div class="col-sm-3" [hidden]="HideRows">
            <ng-select
              [items]="hours"
              formControlName="OutHour"
              [clearable]="false"
              placeholder="Hour">
            </ng-select>
          </div>
          <div class="col-sm-3" [hidden]="HideRows">
            <ng-select
              [items]="minutes"
              formControlName="OutMin"
              [clearable]="false"
              placeholder="Minutes">
            </ng-select>
          </div>
          <div class="col-sm-2" [hidden]="HideRows">&nbsp;</div>
  
          <div class="col-sm-12" [hidden]="HideRows">
              <hr>
          </div>
  
          <div class="col-sm-4 height-34" [hidden]="HideRows"><a href="{{RouteFollowUpAction}}" target="_blank">Action Type</a></div>
          <div class="col-sm-6" [hidden]="HideRows">
            <ng-select
              [items]="FollowUpAction"
              bindLabel="MainDescr"
              bindValue="hdID"
              formControlName="ActionType"
              placeholder="[Not Selected]"
              [clearable]="false">
              <ng-template ng-option-tmp let-item="item">
                <span [title]="item.MainDescr">{{item.MainDescr}}</span>
              </ng-template>
            </ng-select>
          </div>
          <div class="col-sm-2" [hidden]="HideRows">&nbsp;</div>
  
          <div class="col-sm-12" [hidden]="HideRows">
              <hr>
          </div>
  
          <div class="col-sm-4 height-34" [hidden]="HideRows">{{ActionTaken}}<span style="color:red;">*</span></div>
          <div class="col-sm-6"><textarea class="form-control" formControlName="ActionTaken" rows="2" placeholder="Enter Action Description"></textarea>
          </div>
          <div class="col-sm-2">&nbsp;</div>
  
          <div class="col-sm-12">
              <hr>
          </div>
  
          <div class="col-sm-4 height-34">Attachments</div>
          <div class="col-sm-6"><input type='file' formControlName="followupFiles" (change)="onSelectFile($event)" multiple>
          </div>
          <div class="col-sm-2">&nbsp;</div>
  
          <div class="col-sm-12" style="display:none;">
              <hr>
          </div>
  
          <div class="col-sm-4 height-34" style="display:none;">Alert</div>
          <div class="col-sm-6" style="padding:10px;" style="display:none;"><label class="radio-inline"><input type="radio" formControlName="AlertType" value="1" >All Seniors</label>
              <label class="radio-inline"><input type="radio" formControlName="AlertType"  value="0" >Not Required</label>
          </div>
          <div class="col-sm-2" style="display:none;">&nbsp;</div>
  
          <div class="col-sm-12" style="display:none;">
              <hr>
          </div>
          <div class="col-sm-12">&nbsp;</div>
          <div class="col-sm-4">&nbsp;</div>
          <div class="col-sm-4" [hidden]="HideButtonSubmit">
              <div class="form-group col-sm-4" *ngIf="this.RightsID.includes('202046001') || this.RightsID.includes('202046021') ; then AddFollowLink else AddFollow"></div>
              <ng-template #AddFollowLink>
                  <input class="btn btn-primary col-sm-12" type="submit" value={{ButtonCaption}}>
                  <span *ngIf="loading"  class="spinner-border spinner-border" role="status" aria-hidden="true"></span>
              </ng-template>
              <ng-template #AddFollow>
                  &nbsp;
              </ng-template>
  
          </div>
          <div class="col-sm-4">&nbsp;</div>
  
          <div class="col-sm-12"><label style="Display:none;" *ngFor='let urldata of fileurls'>{{urldata}}</label></div>
          <div class="form-group mt-2" style="display:none;">
              <div class="form-check">
                  <input type="checkbox" name="autoClose" id="autoClose" class="form-check-input" checked=true [(ngModel)]="options.autoClose">
                  <label for="autoClose">Auto close alert after three seconds</label>
              </div>
  
          </div>
          <div class="jumbotron p-4">
              <div class="container text-center col-sm-4 alertCssforPopup">
                  <app-alert></app-alert>
                  <router-outlet></router-outlet>
              </div>
          </div>
      </form>
  
  </div> -->
}